"use strict";
exports.__esModule = true;
function SafeString(string) {
  this.string = string;
}
SafeString.prototype.toString = SafeString.prototype.toHTML = function() {
  return "" + this.string;
};
exports["default"] = SafeString;
module.exports = exports["default"];
